import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container, Button } from 'react-bootstrap';
import { convertHexToRgba } from 'common/utils/colorConverter';
import { institutionalWording } from 'common/locale';
import useIsAuthenticated from 'common/hooks/useIsAuthenticated';
import arrow from 'assets/svg/inst.svg';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { getLoanRequestDataAction } from 'features/loanRequest/actions.loanRequest';
import { motion } from 'framer-motion';
import { variants } from '../constants';

const useStyles = makeStyles(({ color }) => ({
  wrapper: {
    background: convertHexToRgba('#ffffff', 70),
    padding: '35px 55px',
    borderRadius: 10,
    '@media (max-width: 992px)': {
      padding: '30px 25px',
    },
  },
  description: {
    color: color.types,
    fontSize: 12,
  },
  list: {
    listStyle: 'none',
    color: color.secondary,
    padding: 0,
    margin: '15px 0',
  },
  item: {
    color: color.types,
    fontSize: 12,
    display: 'flex',
  },
  arrow: {
    marginRight: 20,
    marginLeft: 5,
  },
  synthesis: {
    color: color.types,
    fontSize: 12,
  },
  title: {
    '@media (max-width: 992px)': {
      fontSize: '21px',
      textAlign: 'center',
      marginBottom: '25px!important',
    },
  },
  titleContainer: {
    '@media (max-width: 992px)': {
      marginTop: '-30px!important',
      marginBottom: '0px!important',
    },
  },
  pageTitle: {
    '@media (max-width: 992px)': {
      fontSize: '20px!important',
    },
  },
}));

const Institutional = ({ title, page }) => {
  const classes = useStyles();
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch();
  const handleClick = () => {
    if (isAuthenticated) {
      dispatch(getLoanRequestDataAction());
    } else {
      dispatch(push('/auth'));
    }
  };
  return (
    <motion.div initial='hidden' animate='visible' variants={variants}>
      <Container className={`mt-5 mb-6 ${classes.titleContainer}`}>
        <h1 className={`title1 s-34 mb-5 ${classes.title}`}>{title}</h1>
        <div className={classes.wrapper}>
          <h2 className={`title2 s-24 text-uppercase ${classes.pageTitle}`}>
            {page.text}
          </h2>
          <h3 className='title4 s-15 mb-4'>{page.suTitle}</h3>
          <p className={`${classes.description} mb-3`}>{page.description}</p>
          <ul className={classes.list}>
            {page.items &&
              page.items.length &&
              page.items.map(item => (
                <li className={`${classes.item} mb-3`} key={item}>
                  <img className={classes.arrow} src={arrow} alt='' />
                  <span>{item}</span>
                </li>
              ))}
          </ul>
          <p className={classes.synthesis}> {page.synthesis}</p>
          {page.action && (
            <div className='text-center mt-5 mb-1'>
              <Button
                onClick={handleClick}
                className='py-2 px-4 rounded-pill btn-md'
              >
                {institutionalWording.DEMANDE_CREDIT}
              </Button>
            </div>
          )}
        </div>
      </Container>
    </motion.div>
  );
};

export default Institutional;
